'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ContentPreviewType = void 0;
(function(ContentPreviewType) {
    ContentPreviewType["Audio"] = 'audio';
    ContentPreviewType["Image"] = 'image';
    ContentPreviewType["OfficeDoc"] = 'office';
    ContentPreviewType["PDF"] = 'pdf';
    ContentPreviewType["VideoMux"] = 'mux';
    ContentPreviewType["VideoOther"] = 'video';
    ContentPreviewType["VideoProcessing"] = 'processing';
})(exports.ContentPreviewType || (exports.ContentPreviewType = {}));
//# sourceMappingURL=attachment.js.map
